import { firmwareDownload } from "../../actions/stat";

export default function FirmwareButton({
  link = "",
  statistic = "",
  text = "",
  newTab = false,
}) {
  return (
    <a
      href={link}
      className="firmwareIMGButton"
      onClick={statistic ? () => firmwareDownload(statistic) : undefined}
      target={newTab ? "_blank" : "_self"}
      rel={"noreferrer"}
    >
      <p className="firmwareIMGButtonText">{text || "СКАЧАТЬ"}</p>
    </a>
  );
}
